(function ($) {
    function IsSearchAbleCulture(culture) {
        var isSearchable = false;
        var searchableCultures = $('.sticky-dealer-locator .searchable-cultures').data('searchable-cultures').split(';');
        for (var i = 0; i < searchableCultures.length; i++) {
            var currentCulture = searchableCultures[i].trim();
            if (currentCulture === culture) {
                isSearchable = true;
            }
        }
        return isSearchable;
    }
    $('.dealer-locator-header').click(function() {
        var $this = $(this);
        $this.parents('.sticky-dealer-locator').toggleClass('active');
    });
    $('.sticky-dealer-locator,.dealer-locator-widget').each(function() {
        var $dealerLocator = $(this);
        var $languageSelect = $dealerLocator.find('.language-select');
        var $postalCodeInput = $dealerLocator.find('.postal-code-input');
        var $zipSearchRow = $dealerLocator.find('.zip-search-row');
        var $noZipSearchRow = $dealerLocator.find('.no-zip-search-row');
        var $areaInput = $dealerLocator.find('.area-input');
        $languageSelect.each(function() {
            var $select = $(this);
            var isSearchable = IsSearchAbleCulture($select.val());
            if (isSearchable) {
                $noZipSearchRow.addClass('hidden');
                $zipSearchRow.removeClass('hidden');
                $areaInput.val('');
            } else {
                $noZipSearchRow.removeClass('hidden');
                $zipSearchRow.addClass('hidden');
                $postalCodeInput.val('');
            }
        });
        $languageSelect.change(function () {
            var $select = $(this);
            var isSearchable = IsSearchAbleCulture($select.val());
            if (isSearchable) {
                $noZipSearchRow.addClass('hidden');
                $zipSearchRow.removeClass('hidden');
                $areaInput.val('');
            } else {
                $noZipSearchRow.removeClass('hidden');
                $zipSearchRow.addClass('hidden');
                $postalCodeInput.val('');
            }

        });
    });
    $('.dealer-list-submit').click(function () {
        var $button = $(this);
        var $form = $button.parents('.dealer-locator-form');
        var $postalCodeInput = $form.find('.postal-code-input');
        var postalCodeValue = $postalCodeInput.val();
        $button.attr('href', $button.attr('href') + '?term=' + postalCodeValue);
    });
    $('.dealer-search-submit').click(function () {
        var $button = $(this);
        var $form = $button.parents('.dealer-locator-form');
        var $languageSelect = $form.find('.language-select');
        var $postalCodeInput = $form.find('.postal-code-input');
        var $areaInput = $form.find('.area-input');

        if (!IsSearchAbleCulture($languageSelect.val())) {
            $postalCodeInput.val('');
            $form.attr('action', $form.data('no-zip-search-link'));
        } else {
            $areaInput.val('');
        }
        $form.submit();
    });
})(window.jQuery);